import _classCallCheck from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _inherits from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

/** Error thrown when an HTTP request fails. */
export var HttpError = /*#__PURE__*/function (_Error) {
  _inherits(HttpError, _Error);

  var _super = _createSuper(HttpError);

  /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
   *
   * @param {string} errorMessage A descriptive error message.
   * @param {number} statusCode The HTTP status code represented by this error.
   */
  function HttpError(errorMessage, statusCode) {
    var _this;

    _classCallCheck(this, HttpError);

    var trueProto = (this instanceof HttpError ? this.constructor : void 0).prototype;
    _this = _super.call(this, "".concat(errorMessage, ": Status code '").concat(statusCode, "'"));
    _this.statusCode = statusCode; // Workaround issue in Typescript compiler
    // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200

    _this.__proto__ = trueProto;
    return _this;
  }

  return HttpError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/** Error thrown when a timeout elapses. */

export var TimeoutError = /*#__PURE__*/function (_Error2) {
  _inherits(TimeoutError, _Error2);

  var _super2 = _createSuper(TimeoutError);

  /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  function TimeoutError() {
    var _this2;

    var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "A timeout occurred.";

    _classCallCheck(this, TimeoutError);

    var trueProto = (this instanceof TimeoutError ? this.constructor : void 0).prototype;
    _this2 = _super2.call(this, errorMessage); // Workaround issue in Typescript compiler
    // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200

    _this2.__proto__ = trueProto;
    return _this2;
  }

  return TimeoutError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/** Error thrown when an action is aborted. */

export var AbortError = /*#__PURE__*/function (_Error3) {
  _inherits(AbortError, _Error3);

  var _super3 = _createSuper(AbortError);

  /** Constructs a new instance of {@link AbortError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  function AbortError() {
    var _this3;

    var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "An abort occurred.";

    _classCallCheck(this, AbortError);

    var trueProto = (this instanceof AbortError ? this.constructor : void 0).prototype;
    _this3 = _super3.call(this, errorMessage); // Workaround issue in Typescript compiler
    // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200

    _this3.__proto__ = trueProto;
    return _this3;
  }

  return AbortError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/** Error thrown when the selected transport is unsupported by the browser. */

/** @private */

export var UnsupportedTransportError = /*#__PURE__*/function (_Error4) {
  _inherits(UnsupportedTransportError, _Error4);

  var _super4 = _createSuper(UnsupportedTransportError);

  /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occured on.
   */
  function UnsupportedTransportError(message, transport) {
    var _this4;

    _classCallCheck(this, UnsupportedTransportError);

    var trueProto = (this instanceof UnsupportedTransportError ? this.constructor : void 0).prototype;
    _this4 = _super4.call(this, message);
    _this4.transport = transport;
    _this4.errorType = 'UnsupportedTransportError'; // Workaround issue in Typescript compiler
    // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200

    _this4.__proto__ = trueProto;
    return _this4;
  }

  return UnsupportedTransportError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/** Error thrown when the selected transport is disabled by the browser. */

/** @private */

export var DisabledTransportError = /*#__PURE__*/function (_Error5) {
  _inherits(DisabledTransportError, _Error5);

  var _super5 = _createSuper(DisabledTransportError);

  /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occured on.
   */
  function DisabledTransportError(message, transport) {
    var _this5;

    _classCallCheck(this, DisabledTransportError);

    var trueProto = (this instanceof DisabledTransportError ? this.constructor : void 0).prototype;
    _this5 = _super5.call(this, message);
    _this5.transport = transport;
    _this5.errorType = 'DisabledTransportError'; // Workaround issue in Typescript compiler
    // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200

    _this5.__proto__ = trueProto;
    return _this5;
  }

  return DisabledTransportError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/** Error thrown when the selected transport cannot be started. */

/** @private */

export var FailedToStartTransportError = /*#__PURE__*/function (_Error6) {
  _inherits(FailedToStartTransportError, _Error6);

  var _super6 = _createSuper(FailedToStartTransportError);

  /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occured on.
   */
  function FailedToStartTransportError(message, transport) {
    var _this6;

    _classCallCheck(this, FailedToStartTransportError);

    var trueProto = (this instanceof FailedToStartTransportError ? this.constructor : void 0).prototype;
    _this6 = _super6.call(this, message);
    _this6.transport = transport;
    _this6.errorType = 'FailedToStartTransportError'; // Workaround issue in Typescript compiler
    // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200

    _this6.__proto__ = trueProto;
    return _this6;
  }

  return FailedToStartTransportError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/** Error thrown when the negotiation with the server failed to complete. */

/** @private */

export var FailedToNegotiateWithServerError = /*#__PURE__*/function (_Error7) {
  _inherits(FailedToNegotiateWithServerError, _Error7);

  var _super7 = _createSuper(FailedToNegotiateWithServerError);

  /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
   *
   * @param {string} message A descriptive error message.
   */
  function FailedToNegotiateWithServerError(message) {
    var _this7;

    _classCallCheck(this, FailedToNegotiateWithServerError);

    var trueProto = (this instanceof FailedToNegotiateWithServerError ? this.constructor : void 0).prototype;
    _this7 = _super7.call(this, message);
    _this7.errorType = 'FailedToNegotiateWithServerError'; // Workaround issue in Typescript compiler
    // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200

    _this7.__proto__ = trueProto;
    return _this7;
  }

  return FailedToNegotiateWithServerError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/** Error thrown when multiple errors have occured. */

/** @private */

export var AggregateErrors = /*#__PURE__*/function (_Error8) {
  _inherits(AggregateErrors, _Error8);

  var _super8 = _createSuper(AggregateErrors);

  /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
   *
   * @param {string} message A descriptive error message.
   * @param {Error[]} innerErrors The collection of errors this error is aggregating.
   */
  function AggregateErrors(message, innerErrors) {
    var _this8;

    _classCallCheck(this, AggregateErrors);

    var trueProto = (this instanceof AggregateErrors ? this.constructor : void 0).prototype;
    _this8 = _super8.call(this, message);
    _this8.innerErrors = innerErrors; // Workaround issue in Typescript compiler
    // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200

    _this8.__proto__ = trueProto;
    return _this8;
  }

  return AggregateErrors;
}( /*#__PURE__*/_wrapNativeSuper(Error));